import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { invalidateAvailability, SITE_AVAILABILITY_EVENT } from '@/lib/siteAvailability';

/** One listener for the whole site; no background timer or per-card polling. */
export default function SiteAvailabilityRefresh() {
  const client = useQueryClient();
  const { pathname } = useLocation();
  const last = useRef(0);
  useEffect(() => {
    const refresh = (force = false) => {
      if (document.visibilityState === 'hidden' || pathname.startsWith('/admin')) return;
      if (!force && Date.now() - last.current < 15_000) return;
      last.current = Date.now();
      void invalidateAvailability(client);
    };
    const focus = () => refresh();
    const changed = () => refresh(true);
    if (!pathname.startsWith('/checkout') && !pathname.startsWith('/pedido/')) refresh(true);
    window.addEventListener('focus', focus);
    window.addEventListener('online', focus);
    document.addEventListener('visibilitychange', focus);
    window.addEventListener(SITE_AVAILABILITY_EVENT, changed);
    return () => {
      window.removeEventListener('focus', focus);
      window.removeEventListener('online', focus);
      document.removeEventListener('visibilitychange', focus);
      window.removeEventListener(SITE_AVAILABILITY_EVENT, changed);
    };
  }, [client, pathname]);
  return null;
}